interface ErrorState {
	message: string;
	show: boolean;
}

export interface NicknameFieldState {
	value: string;
	error: ErrorState;
	suggestions: string[];
	valid: boolean | null;
}

export type Action =
	| { type: 'SET_NICKNAME_VALUE'; payload: string }
	| { type: 'SET_NICKNAME_ERROR'; payload: string }
	| { type: 'SET_NICKNAME_SUGGESTIONS'; payload: string[] }
	| { type: 'REMOVE_NICKNAME_ERROR' }
	| { type: 'SHOW_NICKNAME_ERROR' }
	| { type: 'HIDE_NICKNAME_ERROR' }
	| { type: 'RESET_NICKNAME_VALIDITY' }
	| { type: 'SET_NICKNAME_VALIDITY'; payload: boolean | null };


const Reducer = (state: NicknameFieldState, action: Action): NicknameFieldState => {
	switch (action.type) {
		case 'SET_NICKNAME_VALUE':
			return {
				...state,
				value: action.payload,
			};
		case 'SET_NICKNAME_ERROR':
			return {
				...state,
				error: { ...state.error, message: action.payload },
			};
		case 'SET_NICKNAME_SUGGESTIONS':
			return {
				...state,
				suggestions: action.payload,
			};
		case 'REMOVE_NICKNAME_ERROR':
			return {
				...state,
				error: { ...state.error, message: '' },
			};
		case 'SHOW_NICKNAME_ERROR':
			return {
				...state,
				error: { ...state.error, show: true },
			};
		case 'HIDE_NICKNAME_ERROR':
			return {
				...state,
				error: { ...state.error, show: false },
			};
		case 'RESET_NICKNAME_VALIDITY':
			return {
				...state,
				valid: null,
			};
		case 'SET_NICKNAME_VALIDITY':
			return {
				...state,
				valid: action.payload,
			};
		default:
			return state;
	}
};

export default Reducer;
